const messages = {
  title: "Oma profiilini",
  desc: "Tervetuloa henkilökohtaiseen alueeseesi. Täällä voit päivittää tai muokata <br/>tietojasi ja tarkastella postilaatikkoasi.",
  descStaff:
    "Tervetuloa henkilökohtaiseen alueeseesi. Täällä voit päivittää tai muokata tietojasi.",
  buttons: {
    showProfile: "Näytä profiili",
    userProfile: "SIIRRY PERUSTIETOIHIN",
    mailbox: "SIIRRY POSTILAATIKKOON",
    addNewEmail: "Add new email",
  },
  categories: {
    baseData: {
      title: "Perustiedot",
      desc: "Täytä henkilö- ja yritystietosi oikeaa rekisteröintiä varten.",
    },
    mailbox: {
      desc: "Vastaanota tärkeitä viestejä, tilausvahvistuksia ja uutisia postilaatikkoosi.",
    },
    bankstatement: {
      title: "Tilin yhteenveto",
      desc: "Täältä voit tarkastella henkilökohtaisen Bridgestone Plus -tilisi tilaa sekä kertyneitä ja käytettyjä palkintopisteitäsi.",
    },
  },
  profile: {
    general: "HENKILÖTIEDOT YRITYSTIEDOT",
    title: "Perustiedot",
    description:
      "Tervetuloa henkilökohtaiseen alueeseesi. Täällä voit päivittää tai muokata tietojasi.",
    block_description:
      "Tervetuloa henkilökohtaiselle alueellesi. Täältä voit tarkastella tietosi",
    personalData: "HENKILÖTIEDOT",
    password: "Salasana",
    password1: "Salasana (valinnainen)*",
    password2: "Salasana (uudelleen)*",
    formOfAddress: "Osoitteen aloitus",
    choose: "Valitse otsikko",
    mr: "Herra",
    mrs: "Rouva",
    diverse: "Muu",
    firstname: "Etunimi",
    surname: "Sukunimi",
    position: "ASEMA YRITYKSESSÄ",
    operatingData: "YRITYSTIEDOT",
    company: "Yritys",
    legalForm: "Oikeudellinen muoto",
    name: "Nimi",
    streetHouseNr: "Yrityksen osoite",
    street: "Katu",
    postcode: "Postinumero",
    location: "Kaupunki",
    country: "Maa",
    de: "Saksa",
    at: "Itävalta",
    ch: "Sveitsi",
    nl: "Alankomaat",
    it: "Italia",
    language: "Kieli",
    french: "Ranska",
    italian: "Italia",
    german: "Saksa",
    nederland: "Hollanti",
    phone: "Puhelin",
    website: "Verkkosivusto",
    operatingIndicators: "Toimintatunnusluvut",
    tireSale: "Vuosittainen renkaiden myynti, noin kappaleina",
    tireSaleLabel: "Renkaiden myynti suurina määrinä",
    inches: "Näistä ≥ 18 tuumaa (%)",
    inchesLabel: "Näistä 18 tuumaa tai enemmän (%)",
    segmentSale:
      "Renkaiden myynti segmentin mukaan (osuus Budjetti / Keskitaso / Premium %)",
    premBudget: "Premium",
    midBudget: "Keskitaso",
    budBudget: "Budjetti",
    distribution: "KESÄ / TALVI / YMPÄRIVUOTISET JAKAUMA (%)",
    summerIn: "Kohti kesää",
    winterIn: "Talvi on täällä",
    allSeasonIn: "Koko kauden ajan",
    tyreSizes: "Kausisäilytyspaikkojen määrä (renkaita)",
    diffDeliveryAddres: "Lisää toimitusosoite",
    yourEmailAddress: "Sähköpostiosoitteesi.",
    clientNr: "Asiakasnumerot",
    clientNrSingular: "Asiakasnumero",
    clientNrContent:
      "<span class='text-danger fw-bold'>TÄRKEÄÄ - LUE:</span><br /><br /> Jotta renkaiden ostot tukkurilta ja/tai Bridgestonelta voidaan kohdistaa oikein, sinun on <b>annettava vastaavat asiakasnumerosi.</b><br/><br/>Jos sinulla on <b>useita asiakasnumeroita tukkurilta ja/tai Bridgestonelta,</b> esimerkiksi pääliikkeelle ja sivutoimipisteille, anna ensin pääliikkeen asiakasnumero.<br/><br/><b>Muiden asiakasnumeroiden myynnit kohdistetaan sen jälkeen pääliikkeeseesi.</b>",
    supplySource: "Hankintalähde",
    email: "Sähköpostiosoite",
    staffEmail: "Osallistujan sähköpostiosoite",
    registered: "Rekisteröitynyt",
    registeredAt: "Rekisteröitynyt",
    lastLogIn: "Viimeinen kirjautuminen",
    details: "Tiedot",
    inDetail: "{name} yksityiskohtaisesti",
    customerFile: "Asiakastiedot",
    customerHistory: "Asiakashistoria",
    currentYear: "Kuluva vuosi",
    bsClientNr: "Bridgestone-asiakasnumerosi",
    bftClientNr: "Best4Tires-asiakasnumerosi",
    acceptTerms: "Hyväksy osallistumisehdot.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>TÄRKEÄÄ - LUE:</span><br />Kun syötät asiakasnumeron ensimmäistä kertaa, tietosi tarkistetaan niiden tarkkuuden ja jakelukriteerien täyttämisen suhteen. Päätös asiakasnumeroiden aktivoimisesta ja niiden liittämisestä profiiliisi voi kestää jopa 5 arkipäivää.",
    selectWholeSaler: "toimittajalta (valitse)",
    cooperation: "JÄSEN / YHTEISTYÖ",
    error100: "Arvojen summan on oltava 100%.",
    errorRange: "Arvon on oltava välillä 0–100",
    btw_number_label: "yrityksesi ALV-tunniste",
    btw_number: "ALV-numero",
    mobile: "Puhelinnumero",
    mobile_label: "Matkapuhelinnumerosi",
    iban_number: "Yrityksesi IBAN-numero",
    iban_number_label: "IBAN-numero",
    yourCsNr: "Asiakasnumerosi",
    yourLastName: "Sukunimesi",
    positionLabel: "Valitse asema",
    yourFirstName: "Etunimesi",
    companyLabel: "Yritys",
    numberOfSetsOfSeasonalTiresBudget: "Vuosittainen säilytys",
    contactInfo: "Jos sinulla on kysyttävää, ota meihin yhteyttä: {email}",
    addAnotherCsNumber: "Lisää Bridgestone-asiakasnumero",
    activityAndProfile: "TOIMINTA JA PROFIILI",
    financialEmail: "Financial emails",
    indirectCustomNumberHelpMessage:
      "No pudimos detectar la configuración de tu número de cliente. Por favor, revisa tu perfil y confirma si eres un cliente directo o indirecto para continuar.",
    completeProfile: "Täydennä henkilökohtainen profiilisi ja",
    completeProfileBold: "saat lisäksi 200 pistettä.",
  },
  countries: {
    al: "Albania",
    ad: "Andorra",
    at: "Austria",
    be: "Belgium",
    by: "Belarus",
    ba: "Bosnia and Herzegovina",
    bg: "Bulgaria",
    hr: "Croatia",
    cy: "Cyprus",
    cz: "Czechia",
    dk: "Denmark",
    ee: "Estonia",
    fi: "Finland",
    fr: "France",
    ge: "Georgia",
    gr: "Greece",
    es: "Spain",
    nl: "Netherlands",
    ie: "Ireland",
    is: "Iceland",
    kz: "Kazakhstan",
    xk: "Kosovo",
    li: "Liechtenstein",
    lt: "Lithuania",
    lu: "Luxembourg",
    lv: "Latvia",
    mk: "North Macedonia",
    mt: "Malta",
    md: "Moldova",
    mc: "Monaco",
    de: "Germany",
    no: "Norway",
    pl: "Poland",
    pt: "Portugal",
    ru: "Russia",
    ro: "Romania",
    sm: "San Marino",
    rs: "Serbia",
    sk: "Slovakia",
    si: "Slovenia",
    se: "Sweden",
    ch: "Switzerland",
    tr: "Turkey",
    ua: "Ukraine",
    hu: "Hungary",
    gb: "United Kingdom",
    it: "Italy",
    va: "Vatican City",
  },
  addCsNumber: {
    title: "Notice",
    body: "Are you sure you want to save this customer number? The action blocks edit data until the administrator approves it.",
  },
  extraEmailSection: {
    description:
      "Extra email addresses are exclusively used for sending BS+ marketing information and/or financial information and should <b>under no circumstances be used for logging in or managing</b> the Bridgestone PLUS account.",
    optionOne: "For financial info (e.g., bonus specification)",
    optionTwo:
      "For Bridgestone Plus marketing communication (e.g., promotions/newsletters)",
    addNewEmail: "Add new email address",
  },
};

export default {
  messages,
};
